import { url } from "node:inspector";
import { Api } from "../Api";
import { ApiResponse } from "../../../../types/shared";
import { VoucherUsage } from "../../../../types/response/voucher";
import { PlayerVoucherRequestInfo } from "../../../../types/request/voucher";
import { useApiWrapper } from "../../../../hooks/useApiWrapper";

/*

    */
export const Endpoints = Api.injectEndpoints({
  endpoints: (builder) => ({
    getAllPlayers: builder.query({
      query: ({
        club_id,
        currentPage = "",
        limit = "",
        name = "",
        date_added_from = "",
        date_added_to = "",
        gender = "",
        mobile_number = "",
        email = "",
        role = "",
        status = "",
        price_per_player = 0,
        booking_type = "league",
        event_id = "",
        column = "",
        order = "",
      }) =>
        `/club/player/${club_id}?page=${currentPage}&limit=${limit}&name=${name}&gender=${gender}&email=${email}&status=${status}&role=${role}&date_added_from=${date_added_from}&date_added_to=${date_added_to}&mobile_number=${mobile_number}&price_per_player=${price_per_player}&booking_type=${booking_type}&event_id=${event_id}&column=${column}&order=${order}`,
      providesTags: ["players"],
    }),

    editPlayer: builder.mutation({
      query: ({ data, id }) => ({
        url: `/club/player/${id}`,
        method: "PATCH",
        body: data,
        headers: {
          //"Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["players"],
    }),

    getPlayerById: builder.query({
      query: ({ id, club_id }) => `/player/${id}?club_id=${club_id}`,
      providesTags: ["players"],
    }),

    createPlayer: builder.mutation({
      query: ({ data, id }) => ({
        url: `/club/${id}/player`,
        method: "POST",
        body: data,
        headers: {
          //"Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["players"],
    }),
    deletePlayer: builder.mutation({
      query: ({ id, club_id }) => ({
        url: `/player/${id}?club_id=${club_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["players"],
    }),
    getUserBooking: builder.query({
      query: ({ id, club_id, page, limit }) => ({
        url: `/club/player/${id}/bookings?club_id=${club_id}&page=${page}&limit=${limit}`,
        method: "GET",
      }),
      providesTags: ["players"],
    }),
    // packages //
    getAllPackeges: builder.query({
      query: ({
        club_id,
        currentPage = "",
        limit = "",
        name = "",
        date_added_from = "",
        date_added_to = "",
        gender = "",
        mobile_number = "",
        email = "",
        role = "",
        status = "",
      }) =>
        `/club/packages/${club_id}?page=${currentPage}&limit=${limit}&name=${name}&gender=${gender}&email=${email}&status=${status}&role=${role}&date_added_from=${date_added_from}&date_added_to=${date_added_to}`,
      providesTags: ["players"],
    }),
    getAllMemberships: builder.query({
      query: ({
        clubId,
        currentPage = 1,
        limit = 10,
        name = "",
        status = "",
        player_id = "",
        created_by = "",
        date_added_from = "",
        membership_status = "",
        date_added_to = "",
        column = "",
        order = "",
      }) =>
        `/club/${clubId}/membership?page=${currentPage}&limit=${limit}&name=${name}&status=${status}&created_by=${created_by}&date_added_from=${date_added_from}&date_added_to=${date_added_to}&player_id=${player_id}&membership_status=${membership_status}&column=${column}&order=${order}`,
      providesTags: ["memberships"],
    }),
    getAllUsersForMembership: builder.query({
      query: ({
        membershipId = 0,
        name = "",
        status = "",
        clubId = "",
        currentPage = 1,
        limit = 10,
      }) =>
        `/club/membership/users/${membershipId}?name=${name}&status=${status}&club_id=${clubId}&page=${currentPage}&limit=${limit}`,
      providesTags: ["memberships"],
    }),
    getAllCustomerMemberships: builder.query({
      query: ({
        clubId,
        player_id,
        name = "",
        status = "",
        membership_status = "",
        currentPage = 1,
        limit = 10,
      }) =>
        `/player/${player_id}/membership?page=${currentPage}&limit=${limit}`,
      providesTags: ["memberships"],
    }),
    checkPlayerEmail: builder.mutation({
      query: (data) => ({
        url: `/check/player/by_email`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["memberships"],
    }),
    deactivateMembershipForUser: builder.mutation({
      query: ({ player_membership_id = 0, date = "" }) => ({
        url: `club/membership/cancel?player_membership_id=${player_membership_id}&cancellation_date=${date}`,
        method: "POST",
      }),
      invalidatesTags: ["memberships"],
    }),
    pauseMembershipForUser: builder.mutation({
      query: ({
        player_membership_id = 0,
        pause_start = "",
        pause_end = "",
      }) => ({
        url: `api/membership/pause/${player_membership_id}`,
        method: "POST",
        body: { pause_start, pause_end },
      }),
      invalidatesTags: ["memberships"],
    }),
    editMembership: builder.mutation({
      query: ({ data, id }) => ({
        url: `/club/membership/${id}`,
        method: "PATCH",
        body: data,
        headers: {
          //"Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["memberships"],
    }),

    getMembershipById: builder.query({
      query: (id) => `/club/membership/${id}`,
      providesTags: ["memberships"],
    }),
    buyMembership: builder.mutation({
      query: ({ data }) => ({
        url: `/club/player/membership/buy?club_id=${data.club_id}`,
        method: "POST",
        body: data,
        headers: {
          //"Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: [],
    }),
    createMembership: builder.mutation({
      query: ({ data, owner_club_id }) => ({
        url: `/club/membership?club_id=${owner_club_id}`,
        method: "POST",
        body: data,
        headers: {
          //"Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["memberships"],
    }),
    activationMembership: builder.mutation({
      query: (query) => ({
        url: `/club/membership/status/${query.id}?action=${
          query.isForceDelete ? "force_deactivate" : "soft_deactivate"
        }`,
        method: "POST",
        body: { "disabled-enabled": query.status },
        headers: {
          //"Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["memberships"],
    }),
    getAllClubPaidPackages: builder.query({
      query: ({
        club_id,
        limit = 10,
        currentPage = 1,
        name = "",
        column = "",
        order = "",
        all = false,
      }) =>
        `/club/${club_id}/packages?limit=${limit}&page=${currentPage}&column=${column}&order=${order}&name=${name}&all=${all}`,
      providesTags: ["players"],
    }),

    getAllWallet: builder.query({
      query: ({
        club_id,
        limit = 10,
        currentPage = 1,
        column = "",
        order = "",
        name = "",
        voucher_type = "",
        status = "",
      }) =>
        `/club/${club_id}/vouchers?limit=${limit}&page=${currentPage}&column=${column}&order=${order}&name=${name}&status=${status}&voucher_type=${voucher_type}`,
      providesTags: ["players"],
    }),
    getPackageById: builder.query({
      query: ({ package_id }) => `/club/customer_package/${package_id}`,
      providesTags: ["players"],
    }),
    CancelPackage: builder.mutation({
      query: (query) => ({
        url: `/club/inactive_customer_package/${query.packegeId}?with_refund=${query.with_refund}`,
        method: "PATCH",
        body: {},
        headers: {
          //"Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["memberships"],
    }),
    getAllWalletServices: builder.query({
      query: ({ org_id = 0, type = "voucher" }) =>
        `/org/${org_id}/services?org_id=${org_id}&type=${type}`,
      providesTags: ["players"],
    }),
    getAllWalletUsers: builder.query({
      query: ({
        club_id,
        wallet_id,
        limit,
        currentPage = 1,
        column = "",
        order = "",
      }) =>
        `/club/${club_id}/voucher_users/${wallet_id}?limit=${limit}&page=${currentPage}&column=${column}&order=${order}`,
      providesTags: ["players"],
    }),
    getWalletById: builder.query({
      query: ({ club_id, wallet_id }) =>
        `/club/${club_id}/voucher/${wallet_id}`,
      providesTags: ["players"],
    }),
    createWallet: builder.mutation({
      query: ({ club_id, data }) => ({
        url: `/club/${club_id}/voucher`,
        method: "POST",
        body: data,
        headers: {
          //"Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["players"],
    }),

    editWallet: builder.mutation({
      query: ({ club_id, wallet_id, data }) => ({
        url: `/club/${club_id}/voucher/${wallet_id}`,
        method: "PATCH",
        body: data,
        headers: {
          //"Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["players"],
    }),

    addUserToWallet: builder.mutation({
      query: ({ club_id, wallet_id, data }) => ({
        url: `/club/${club_id}/add_player_voucher/${wallet_id}?player_id=${data?.player_id}&payment_method_id=${data?.payment_method_id}`,
        method: "POST",
        body: data,
        headers: {
          //"Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["players"],
    }),
    getWalletUserById: builder.query({
      query: ({ club_id, wallet_id }) =>
        `/club/${club_id}/voucher_user/${wallet_id}`,
      providesTags: ["players"],
    }),
    activationWallet: builder.mutation({
      query: ({ club_id, wallet_id, status }) => ({
        url: `/club/${club_id}/activation_voucher/${wallet_id}?command=${status}`,
        method: "PATCH",
        body: {},
      }),

      invalidatesTags: ["players"],
    }),
    activationUserForWallet: builder.mutation({
      query: ({ club_id, wallet_id, status, reason }) => ({
        url: `/club/${club_id}/activation_voucher_user/${wallet_id}?command=${status}`,
        method: "PATCH",
        body: { reason: reason },
      }),

      invalidatesTags: ["players"],
    }),
    playerVouchers: builder.query<
      ApiResponse<VoucherUsage[]>,
      PlayerVoucherRequestInfo
    >({
      query: ({
        club_id,
        player_id,
        price = "",
        service = "",
        method = "voucher",
        all = false,
      }) =>
        `/club/${club_id}/player_voucher/${player_id}?price=${price}&service=${service}&method=${method}&all=${all}`,
      providesTags: ["players"],
    }),
    AllPlayerVouchers: builder.query({
      query: ({
        club_id,
        player_id,
        name = "",
        expiry_date = "",
        status = "",
      }) =>
        `/club/${club_id}/player/${player_id}/vouchers?name=${name}&expiry_date=${expiry_date}&status=${status}`,
      providesTags: ["players"],
    }),
    ExportPlayerVoucherTransactions: builder.query({
      query: ({ club_id, voucher_user_id }) =>
        `/club/${club_id}/voucher_user/${voucher_user_id}/export`,
      providesTags: ["players"],
      keepUnusedDataFor: 0,
    }),
    exportPlayerVouchers: builder.query({
      query: ({ club_id, player_id, vouchers = [] }) =>
        `/club/${club_id}/player/${player_id}/vouchers/export?voucher_ids=[${vouchers}]`,
      providesTags: ["players"],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetPackageByIdQuery,
  useExportPlayerVoucherTransactionsQuery,
  useExportPlayerVouchersQuery,
  useCancelPackageMutation,
  useEditPlayerMutation,
  useGetPlayerByIdQuery,
  useCreatePlayerMutation,
  useDeletePlayerMutation,
  useActivationMembershipMutation,
  useCreateMembershipMutation,
  useEditMembershipMutation,
  useGetMembershipByIdQuery,
  useBuyMembershipMutation,
  useGetAllUsersForMembershipQuery,
  useDeactivateMembershipForUserMutation,
  usePauseMembershipForUserMutation,
  useCheckPlayerEmailMutation,
  useCreateWalletMutation,
  useGetAllWalletServicesQuery,
  useGetAllWalletUsersQuery,
  useGetWalletByIdQuery,
  useEditWalletMutation,
  useAddUserToWalletMutation,
  useGetWalletUserByIdQuery,
  useActivationWalletMutation,
  useActivationUserForWalletMutation,
  usePlayerVouchersQuery,
  useGetUserBookingQuery,
  useAllPlayerVouchersQuery,
} = Endpoints;
export const useGetAllPlayersQuery = (query: any, options?: any) =>
  useApiWrapper(Endpoints.useGetAllPlayersQuery, query, options);
export const useGetAllMembershipsQuery = (query: any, options?: any) =>
  useApiWrapper(Endpoints.useGetAllMembershipsQuery, query, options);
export const useGetAllCustomerMembershipsQuery = (query: any, options?: any) =>
  useApiWrapper(Endpoints.useGetAllCustomerMembershipsQuery, query, options);
export const useGetAllWalletQuery = (query: any, options?: any) =>
  useApiWrapper(Endpoints.useGetAllWalletQuery, query, options);
export const useGetAllClubPaidPackagesQuery = (query: any, options?: any) =>
  useApiWrapper(Endpoints.useGetAllClubPaidPackagesQuery, query, options);
